import React from 'react';
import LoanRepayment from './components/LoanRepayment'
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <LoanRepayment mixesForWave={2} />
  )
}

export default App;
